import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is the age range for Tumble Gym programs?",
    answer: "Our programs are designed for kids aged 1-14years."
  },
  {
    question: "What is the staff to child ratio?",
    answer: " We maintain a staff-to-child ratio of 1:6 to ensure personalized attention and safety."
  },
  {
    question: "What safety measures do you have in place?",
    answer: "We have a rigorous safety protocol, including soft landing surfaces, safety mats, and trained staff."
  },
  {
    question: "Can I stay and watch my child's class",
    answer: "Yes, we have a designated viewing area for parents."
  },
  {
    question: "How do I enroll my child in a program?",
    answer: "You can enroll online through our website or by visiting our center."
  }
];

export const FAQ = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 via-white to-blue-50">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600">
            Find answers to common questions about our gymnastics programs
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-2xl shadow-lg p-6 md:p-8"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <AccordionItem value={`item-${index}`} className="border rounded-lg px-4 hover:bg-gray-50">
                  <AccordionTrigger className="text-left font-semibold text-primary">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};